import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { withNavItem } from './withNavItem';

class NavItemBits extends Component {
  constructor() {
    super();
    this.rendered = false;
  }
  componentDidMount() {
    this.rendered = true;
  }
  render() {
    this.props.isActiveLinkFunc(this.props.location.pathname === '/bits/');

    return (

      <NavLink onClick={e => this.props.handleClick(e)} className={`nav-link nav-link--bits ${this.props.imagesLoadedClass}`} activeClassName="nav-link--active" to="/bits/">
        <span ref={el => this.props.navLinkFunc(el, this.rendered)} onMouseMove={e => this.props.mousemoveFn(e)} onMouseEnter={e => this.props.mouseenterFn(e)} onMouseLeave={e => this.props.mouseleaveFn(e)} className={`${this.props.wobbling} nav-link__inner`}>
          <span className="nav-link__letter-holder letter-b">
            <span className="nav-link__letter">B</span>
            <span className="letter-strokes letter-strokes--b">
              <span className="b-left-stroke letter-stroke" style={{ transform: this.props.groupB }}>
                <svg className="letter-stroke__svg" viewBox="0 0 109 322">
                  <mask id="b-left-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0c0,0,0.1,116-0.5,197.8S58,322.5,58,322.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#b-left-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/b-left-stroke@2x.jpg" width="109" height="322" />
                </svg>
              </span>
              <span className="b-top-stroke letter-stroke" style={{ transform: this.props.groupD }}>
                <svg className="letter-stroke__svg" viewBox="0 0 169 212">
                  <mask id="b-top-stroke-mask" width="209.6px" height="229.6px">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" style={{ strokeWidth: '106' }} d="M2.3,53.2c42.7,0,48.1-0.9,82.7,1.8c23.7,1.9,38.4,26.9,36.3,57c-1,14-11.3,33.3-31,41.1 c-29.6,11.7-53.8,7.1-90,6.9" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#b-top-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/b-top-stroke@2x.jpg" width="169" height="212" />
                </svg>
              </span>
              <span className="b-bottom-stroke letter-stroke" style={{ transform: this.props.groupC }}>
                <svg className="letter-stroke__svg" viewBox="0 0 166 212">
                  <mask id="b-bottom-stroke-mask" width="209.6px" height="229.6px">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" style={{ strokeWidth: '106' }} d="M0,53.2c42.7,0,50.1-0.9,84.7,1.8c23.7,1.9,38.4,26.9,36.3,57c-1,14-11.3,33.3-31,41.1 c-29.6,11.7-50.8,7.1-87,6.9" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#b-bottom-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/b-bottom-stroke@2x.jpg" width="166" height="212" />
                </svg>
              </span>
            </span>
          </span>
          <span className="nav-link__letter-holder letter-i">
            <span className="nav-link__letter">I</span>
            <span className="letter-strokes letter-strokes--i">
              <span className="i-stroke letter-stroke" style={{ transform: this.props.groupB }}>
                <svg className="letter-stroke__svg" viewBox="0 0 107 309">
                  <mask id="i-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0c0,0,0.1,116-0.5,197.8S58,322.5,58,322.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#i-mask)" className="letter-stroke__svg-image" xlinkHref="/img/i@2x.jpg" width="107" height="309" />
                </svg>
              </span>
            </span>
          </span>

          <span className="nav-link__letter-holder letter-t">
            <span className="nav-link__letter">T</span>
            <span className="letter-strokes letter-strokes--t">
              <span className="t-top-stroke letter-stroke" style={{ transform: this.props.groupA }}>
                <svg className="letter-stroke__svg" viewBox="0 0 270 111">
                  <mask id="t-top-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M0.2,58c0,0,22.5-0.1,104.3,0.5S270.7,59,270.7,59" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#t-top-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/t-top-stroke@2x.jpg" width="270" height="111" />
                </svg>
              </span>
              <span className="t-bottom-stroke letter-stroke" style={{ transform: this.props.groupC }}>
                <svg className="letter-stroke__svg" viewBox="0 0 106 221">
                  <mask id="t-bottom-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0.2c0,0,0.1,22.5-0.5,104.3S58,229.2,58,229.2" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#t-bottom-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/t-bottom-stroke@2x.jpg" width="106" height="221" />
                </svg>
              </span>
            </span>
          </span>

          <span className="nav-link__letter-holder letter-s">
            <span className="nav-link__letter">S</span>
            <span className="letter-strokes letter-strokes--s">
              <span className="s-stroke letter-stroke" style={{ transform: this.props.groupD }}>
                <svg className="letter-stroke__svg" viewBox="0 0 257 328">
                  <mask id="s-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M239.7,84.5c-20-12-52-26-72-30s-67-3-82,43s53,70,75,79s68,25,50,66s-69,44-107,27c-36.5-16.3-51-27-65-42" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#s-mask)" className="letter-stroke__svg-image" xlinkHref="/img/s@2x.jpg" width="257" height="328" />
                </svg>
              </span>
            </span>
          </span>
        </span>
      </NavLink>

    );
  }
}

NavItemBits.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  activePaths: PropTypes.func.isRequired,
  svgImages: PropTypes.func.isRequired,
  imagesLoadedClass: PropTypes.string.isRequired,
  isActiveLinkFunc: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  navLinkFunc: PropTypes.func.isRequired,
  mousemoveFn: PropTypes.func.isRequired,
  mouseenterFn: PropTypes.func.isRequired,
  mouseleaveFn: PropTypes.func.isRequired,
  wobbling: PropTypes.string.isRequired,
  groupA: PropTypes.string.isRequired,
  groupB: PropTypes.string.isRequired,
  groupC: PropTypes.string.isRequired,
  groupD: PropTypes.string.isRequired,
};

export default withNavItem(NavItemBits);



// WEBPACK FOOTER //
// ./src/components/NavItemBits.js